import { V2, newV2 } from './lib/V2';

export class Input {

  pressed: Partial<Record<string, boolean>> = {};
  keyDown: Partial<Record<string, boolean>> = {};
  mouse = newV2();

  private enabled = false;

  private onKeyDown = (e: KeyboardEvent) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (!this.pressed[e.code]) {
      this.keyDown[e.code] = true;
    }
    this.pressed[e.code] = true;
  };

  private onKeyUp = (e: KeyboardEvent) => {
    this.pressed[e.code] = false;
  };

  private onMouseMove = (e: MouseEvent) => {
    this.mouse[0] = e.clientX;
    this.mouse[1] = e.clientY;
  };

  enable() {
    if (this.enabled) return;
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('mousemove', this.onMouseMove);
    this.enabled = true;
  }

  disable() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('mousemove', this.onMouseMove);
    this.enabled = false;
  }

  reset = () => {
    this.keyDown = {};
  };

  getAxes(): V2 {
    const axes: V2 = newV2();
    if (this.pressed.KeyW) { axes[1] -= 1; }
    if (this.pressed.KeyS) { axes[1] += 1; }
    if (this.pressed.KeyA) { axes[0] -= 1; }
    if (this.pressed.KeyD) { axes[0] += 1; }
    return axes;
  }
}
